// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__gAVA5","errorLogs":"styles_errorLogs__bAAin"};